<section class="section-footer content-padding negative-padding-offset d-block d-sm-none {{ classes }}">
  <div class="container-fluid">
    <div class="button-wrapper text-center">
      <button *ngIf="buttonText && buttonUrl.indexOf('//') !== 0" class="btn {{ buttonClass }}" type="submit" [routerLink]="buttonUrl" [queryParams]="buttonParams">{{ buttonText }}</button>
      <button *ngIf="buttonText && buttonUrl.indexOf('//') === 0" class="btn {{ buttonClass }}" type="submit" (click)="goto(buttonUrl)">{{ buttonText }}</button>
      <ng-content></ng-content>
    </div>
  </div>
</section>
